import React from 'react';
import PageTitle from '../../02-molecules/PageTitle/PageTitle.component';
import SiteHeader from '../../03-organisms/site/SiteHeader/SiteHeader.component';
import SiteFooter from '../../03-organisms/site/SiteFooter/SiteFooter.component';
import bem from '../../_utils/bem';
import { menuItemPropType } from '../../02-molecules/menus/MenuItem.component';

var Layout = function Layout(_ref) {
  var _ref$mainBlock = _ref.mainBlock,
      mainBlock = _ref$mainBlock === void 0 ? 'main-content' : _ref$mainBlock,
      _ref$mainModifiers = _ref.mainModifiers,
      mainModifiers = _ref$mainModifiers === void 0 ? [] : _ref$mainModifiers,
      _ref$layoutModifiers = _ref.layoutModifiers,
      layoutModifiers = _ref$layoutModifiers === void 0 ? [] : _ref$layoutModifiers,
      _ref$mainContentModif = _ref.mainContentModifiers,
      mainContentModifiers = _ref$mainContentModif === void 0 ? [] : _ref$mainContentModif,
      breadcrumbs = _ref.breadcrumbs,
      menu = _ref.menu,
      title = _ref.title,
      footerItems = _ref.footerItems,
      hasSidebar = _ref.hasSidebar,
      hero = _ref.hero,
      sidebar = _ref.sidebar,
      children = _ref.children;

  if (hasSidebar) {
    mainModifiers.push('with-sidebar');
    mainContentModifiers.push('with-sidebar');
  }

  return /*#__PURE__*/React.createElement("div", {
    className: bem('layout-container', layoutModifiers)
  }, /*#__PURE__*/React.createElement(SiteHeader, {
    breadcrumbs: breadcrumbs,
    menu: menu
  }), /*#__PURE__*/React.createElement("div", {
    className: bem('main', '', mainModifiers)
  }, /*#__PURE__*/React.createElement("a", {
    id: "main-content",
    tabIndex: "-1"
  }), /*#__PURE__*/React.createElement(PageTitle, null, title), hasSidebar && /*#__PURE__*/React.createElement("aside", {
    className: "main-sidebar",
    role: "complementary"
  }, sidebar), hero, /*#__PURE__*/React.createElement("main", {
    role: "main",
    className: bem(mainBlock, '', mainContentModifiers)
  }, children)), /*#__PURE__*/React.createElement(SiteFooter, {
    items: footerItems
  }));
};

export default Layout;